import axios from 'axios';

const api = axios.create({
  //baseURL: 'https://api-sdc.herokuapp.com'
  headers: {'Content-Type': 'multipart/form-data' },
  baseURL: 'http://ideiasadman.com.br/mail'
});

export default api;